import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderDelivered } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type DeliverOrderProps = {
  formData: IOrderDelivered;
} & RequestsProps;

export type UseDeliverOrderReturn = {
  create: (props: DeliverOrderProps) => Promise<void>;
} & UseLoadingReturn;

const useDeliverOrder = (): UseDeliverOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderDelivered>({
    operation: (formData) => orderStatusService.deliver(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useDeliverOrder;
